export const init = () => {
  const MAPS_CALLBACK = 'App.es6.views.venue.maps_callback';
  const API_KEY = window.GOOGLE_MAPS_API_KEY;

  const loadGoogleMaps = () => {
    if (window.google && window.google.maps) {
      App.es6.views.venue.maps_callback(); // MAPS_CALLBACK
      return;
    }

    $.getScript(`https://maps.googleapis.com/maps/api/js?v=3.57&loading=async&language=en&callback=${MAPS_CALLBACK}&key=${API_KEY}&libraries=places,marker`);
  };

  window.inView('#map-canvas').once('enter', () => {
    loadGoogleMaps();
  });

  return {
    loadGoogleMaps,
  };
};
